"use client";

import { useCallback, useRef, useState } from "react";
type UseConsentGateOptions = {
  onCancel: () => void;
  trackConsent: () => void;
  onConsentAccepted: () => void | Promise<void>;
};
export function useConsentGate({
  onCancel,
  trackConsent,
  onConsentAccepted
}: UseConsentGateOptions) {
  const [consentChecked, setConsentChecked] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const verificationInProgressRef = useRef(false);
  const handleConsentAgree = useCallback(async () => {
    if (!consentChecked) return;
    if (verificationInProgressRef.current) return;
    verificationInProgressRef.current = true;
    setIsVerifying(true);
    setError(null);
    try {
      trackConsent();
      await onConsentAccepted();
    } catch {
      setError("Failed to save consent. Please try again.");
    } finally {
      setIsVerifying(false);
      verificationInProgressRef.current = false;
    }
  }, [consentChecked, trackConsent, onConsentAccepted]);
  return {
    consentChecked,
    setConsentChecked,
    error,
    isVerifying,
    handleConsentAgree,
    handleConsentCancel: onCancel
  };
}